
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/courses/data-science",
      function () {
        return require("private-next-pages/next/courses/data-science.tsx");
      }
    ]);
  